/**
 * @file ShelfLifeDaysField.tsx
 * @description «Срок годности по умолчанию» в карточке товара (phase19.22,
 * W20, макет §6): пара полей «дней» + «месяцев» (`DaysMonthsField`).
 *
 * Хранится в днях (`Product.shelfLifeDays`), месяцы — второй способ ввода.
 * Пустое поле — берётся срок вида: плейсхолдеры «365 — из вида „Пищевой“» и
 * «12,2 — из вида». Видимость решает секция: поле показывается, только если
 * действующий вид требует срок.
 */

import type { ProductKind } from "../../../lib/api-product-kinds";
import { daysToMonthsText } from "../../../lib/product-kind-format";
import { DaysMonthsField } from "./DaysMonthsField";

interface Props {
  /** Дни строкой; "" — как у вида. */
  value: string;
  onChange: (value: string) => void;
  /** Действующий вид — источник плейсхолдера. */
  kind: ProductKind | null;
  disabled?: boolean;
}

export function ShelfLifeDaysField({ value, onChange, kind, disabled }: Props) {
  const kindDays = kind?.defaultShelfLifeDays ?? null;

  return (
    <div className="flex flex-col gap-1.5">
      <DaysMonthsField
        id="p-shelf-life"
        label="Срок годности"
        value={value}
        onChange={onChange}
        // Сервер принимает у товара до 36500 дней (sanity-граница DTO).
        maxDays={36500}
        daysPlaceholder={kindDays ? `${kindDays} — из вида «${kind?.name ?? ""}»` : "Например, 365"}
        monthsPlaceholder={kindDays ? `${daysToMonthsText(kindDays)} — из вида` : "Например, 12"}
        disabled={disabled}
      />
      <p className="text-xs text-on-surface-variant">
        Подставится в приёмке, если поставщик указал только дату изготовления.
        Хранится в днях; месяц — 30 дней.
      </p>
    </div>
  );
}
